import { Box, Grid, Paper, Typography } from "@material-ui/core";
import React from "react";
import { formatWeight } from "utils/weight";

export const BoxDetails = ({ translate, classes, selectedBox, selectedPallet }) => {
	if (!selectedBox) {
		return <Typography>{translate("tab.pallets.boxes.no_box_selected")}</Typography>;
	}

	return (
		<Box>
			<Typography variant="h5" className={classes.sectionTitle}>
				{translate("tab.pallets.box_information")}
			</Typography>

			<Grid container spacing={3}>
				<Grid item xs={12} md={6}>
					<Paper className={classes.infoCard}>
						<Typography variant="h6" gutterBottom color="primary">
							{translate("tab.pallets.box_details")}
						</Typography>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.sscc")}:
							</Typography>
							<Typography className={classes.infoValue}>{selectedBox.sscc || "N/A"}</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.net_weight")}:
							</Typography>
							<Typography className={classes.infoValue}>
								{formatWeight(selectedBox.net_weight, selectedBox.weight_unit_code)}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.weight_unit_code")}:
							</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.weight_unit_code || "N/A"}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.external_id")}:
							</Typography>
							<Typography className={classes.infoValue}>
								{selectedBox.ext_box_id || "N/A"}
							</Typography>
						</Box>
					</Paper>
				</Grid>

				<Grid item xs={12} md={6}>
					<Paper className={classes.infoCard}>
						<Typography variant="h6" gutterBottom color="primary">
							{translate("tab.pallets.product_information")}
						</Typography>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.product_number")}:
							</Typography>
							<Typography className={classes.infoValue}>
								{selectedPallet?.product_number || "N/A"}
							</Typography>
						</Box>

						<Box className={classes.infoRow}>
							<Typography className={classes.infoLabel}>
								{translate("tab.pallets.boxes.product_name")}:
							</Typography>
							<Typography className={classes.infoValue}>
								{selectedPallet?.product_name || "N/A"}
							</Typography>
						</Box>
					</Paper>
				</Grid>
			</Grid>
		</Box>
	);
};
